import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../redux';
import SurveyPopover from 'src/views/Pages/Surveys/SurveyPopover';
import Announcement from '../Announcements';
import SurveyChecker from 'src/views/Pages/Surveys/SurveyChecker';

const FloatElementsManager = () => {
  const [activeElement, setActiveElement] = useState('');
  const { openSurvey, openAnnouncement } = useSelector((state: ReduxState) => ({
    openSurvey: state.Survey.open,
    openAnnouncement: state.Announcement.announcement !== null,
  }));

  useEffect(() => {
    if (openSurvey) {
      setActiveElement('Survey');
    } else if (openAnnouncement) {
      setActiveElement('Announcement');
    } else {
      setActiveElement('');
    }
  }, [openSurvey, openAnnouncement]);

  return (
    <>
      <SurveyChecker />
      {activeElement === 'Survey' && <SurveyPopover />}
      {activeElement === 'Announcement' && <Announcement />}
    </>
  );
};

export default FloatElementsManager;
